(function () {
  'use strict';

  // Libellés + phrase de reco par préoccupation (= 1 produit chacune)
  var CONCERNS = {
    bouffees: {
      label: 'Bouffées de chaleur & sommeil',
      why: 'Pour apaiser tes bouffées de chaleur et retrouver des nuits sereines.'
    },
    flore: {
      label: 'Confort intime & flore',
      why: 'Pour rééquilibrer ta flore intime et retrouver ton confort au quotidien.'
    },
    libido: {
      label: 'Libido & plaisir',
      why: 'Pour raviver ton désir et tes sensations.'
    },
    secheresse: {
      label: 'Sécheresse intime',
      why: "Pour soulager la sécheresse et l'inconfort, dès l'application."
    }
  };

  // 6 questions. score = points ajoutés à une préoccupation.
  var QUESTIONS = [
    {
      id: 'age', type: 'single', required: true,
      section: 'Faisons le point sur ta situation',
      title: 'Quel est ton âge ?',
      options: [
        { label: 'Moins de 35 ans', value: 'moins-35' },
        { label: '35 à 40 ans', value: '35-40' },
        { label: '41 à 45 ans', value: '41-45' },
        { label: '46 à 50 ans', value: '46-50' },
        { label: '51 à 55 ans', value: '51-55' },
        { label: 'Plus de 55 ans', value: 'plus-55' }
      ]
    },
    {
      id: 'stage', type: 'single', required: true,
      section: 'Faisons le point sur ta situation',
      title: 'Où en es-tu dans ton parcours ?',
      options: [
        { label: 'Premiers signes, mes cycles changent (périménopause)', value: 'perimenopause' },
        { label: 'Cycles très irréguliers ou parfois absents', value: 'cycles-irreguliers' },
        { label: 'Plus de règles depuis +12 mois (ménopause)', value: 'menopause' },
        { label: 'Je ne sais pas encore', value: 'inconnu' }
      ]
    },
    {
      id: 'symptomes', type: 'multi', required: true,
      section: 'Tes ressentis',
      title: "Qu'est-ce qui te pèse le plus en ce moment ?",
      hint: 'Plusieurs choix possibles',
      options: [
        { label: 'Bouffées de chaleur / sueurs nocturnes', value: 'bouffees', score: { bouffees: 2 } },
        { label: 'Sommeil perturbé', value: 'sommeil', score: { bouffees: 1 } },
        { label: "Fatigue / manque d'énergie", value: 'fatigue', score: { bouffees: 1 } },
        { label: 'Humeur, irritabilité ou anxiété', value: 'humeur', score: { bouffees: 1 } },
        { label: 'Brouillard mental', value: 'brainfog', score: { bouffees: 1 } },
        { label: 'Rien de tout ça', value: 'rien', exclusive: true }
      ]
    },
    {
      id: 'intime', type: 'multi', required: true,
      section: 'Ton équilibre intime',
      title: 'Côté intime, ressens-tu… ?',
      hint: 'Plusieurs choix possibles',
      options: [
        { label: 'De la sécheresse', value: 'secheresse', score: { secheresse: 2 } },
        { label: 'Des irritations ou pertes inhabituelles', value: 'irritations', score: { flore: 2 } },
        { label: 'Rien de particulier', value: 'rien', exclusive: true }
      ]
    },
    {
      id: 'libido', type: 'single', required: true,
      section: 'Ton équilibre intime',
      title: 'Et côté libido / plaisir ?',
      options: [
        { label: 'Pas de changement', value: 'aucun' },
        { label: 'Une baisse légère', value: 'legere', score: { libido: 2 } },
        { label: 'Une baisse marquée', value: 'marquee', score: { libido: 3 } }
      ]
    },
    {
      id: 'priorite', type: 'single', required: true,
      section: 'Ta priorité',
      title: 'Si tu devais agir sur UNE chose en priorité ?',
      options: [
        { label: 'Apaiser les bouffées & mieux dormir', value: 'bouffees', score: { bouffees: 4 } },
        { label: 'Retrouver mon confort intime (flore)', value: 'flore', score: { flore: 4 } },
        { label: 'Soulager la sécheresse', value: 'secheresse', score: { secheresse: 4 } },
        { label: 'Raviver ma libido & mon plaisir', value: 'libido', score: { libido: 4 } }
      ]
    }
  ];

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function findOpt(q, v) {
    for (var i = 0; i < q.options.length; i++) { if (q.options[i].value === v) return q.options[i]; }
    return null;
  }
  function byId(id) {
    for (var i = 0; i < QUESTIONS.length; i++) { if (QUESTIONS[i].id === id) return QUESTIONS[i]; }
    return null;
  }

  function init(root) {
    if (root.__quizInit) return;
    root.__quizInit = true;

    var products = {};
    try { products = JSON.parse(root.querySelector('[data-quiz-products]').textContent); } catch (e) { products = {}; }

    var els = {
      intro: root.querySelector('[data-quiz-intro]'),
      steps: root.querySelector('[data-quiz-steps]'),
      question: root.querySelector('[data-quiz-question]'),
      progressBar: root.querySelector('[data-quiz-progress-bar]'),
      progressLabel: root.querySelector('[data-quiz-progress-label]'),
      back: root.querySelector('[data-quiz-back]'),
      next: root.querySelector('[data-quiz-next]'),
      results: root.querySelector('[data-quiz-results]'),
      start: root.querySelector('[data-quiz-start]')
    };

    var state = { index: 0, answers: {} };
    var N = QUESTIONS.length;

    els.start.addEventListener('click', function () {
      els.intro.hidden = true;
      els.steps.hidden = false;
      renderQuestion();
    });
    els.back.addEventListener('click', function () {
      if (state.index > 0) {
        state.index--;
        renderQuestion();
      } else {
        els.steps.hidden = true;
        els.intro.hidden = false;
      }
    });
    els.next.addEventListener('click', function () { advance(); });

    function renderQuestion() {
      var q = QUESTIONS[state.index];
      var selected = state.answers[q.id] || (q.type === 'multi' ? [] : null);

      var html = '';
      if (q.section) html += '<p class="quiz__section">' + escapeHtml(q.section) + '</p>';
      html += '<h3 class="quiz__q-title">' + escapeHtml(q.title) + '</h3>';
      if (q.hint) html += '<p class="quiz__hint">' + escapeHtml(q.hint) + '</p>';
      html += '<div class="quiz__options" role="group">';
      q.options.forEach(function (opt, i) {
        var isSel = q.type === 'multi' ? selected.indexOf(opt.value) > -1 : selected === opt.value;
        html += '<button type="button" class="quiz__option' + (isSel ? ' is-selected' : '') +
          '" data-index="' + i + '" aria-pressed="' + (isSel ? 'true' : 'false') + '">' +
          '<span class="quiz__option-label">' + escapeHtml(opt.label) + '</span>' +
          '<span class="quiz__option-check" aria-hidden="true"></span>' +
          '</button>';
      });
      html += '</div>';
      els.question.innerHTML = html;

      els.progressBar.style.width = Math.round((state.index / N) * 100) + '%';
      els.progressLabel.textContent = 'Question ' + (state.index + 1) + ' / ' + N;
      els.back.hidden = false;
      els.next.hidden = q.type !== 'multi'; // les choix uniques avancent automatiquement

      els.question.querySelectorAll('.quiz__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var opt = q.options[parseInt(btn.getAttribute('data-index'), 10)];
          if (q.type === 'multi') {
            var arr = (state.answers[q.id] || []).slice();
            if (opt.exclusive) {
              arr = arr.indexOf(opt.value) > -1 ? [] : [opt.value];
            } else {
              // retire toute option exclusive déjà cochée
              arr = arr.filter(function (v) { var o = findOpt(q, v); return o && !o.exclusive; });
              if (arr.indexOf(opt.value) > -1) arr = arr.filter(function (v) { return v !== opt.value; });
              else arr.push(opt.value);
            }
            state.answers[q.id] = arr;
            renderQuestion();
          } else {
            state.answers[q.id] = opt.value;
            advance();
          }
        });
      });
    }

    function validate() {
      var q = QUESTIONS[state.index];
      if (!q.required) return true;
      var a = state.answers[q.id];
      return q.type === 'multi' ? !!(a && a.length) : !!a;
    }

    function advance() {
      if (!validate()) return;
      if (state.index < N - 1) { state.index++; renderQuestion(); }
      else showResults();
    }

    function computeScores() {
      var scores = { bouffees: 0, flore: 0, libido: 0, secheresse: 0 };
      QUESTIONS.forEach(function (q) {
        var a = state.answers[q.id];
        if (!a) return;
        (q.type === 'multi' ? a : [a]).forEach(function (v) {
          var opt = findOpt(q, v);
          if (opt && opt.score) {
            Object.keys(opt.score).forEach(function (c) { scores[c] += opt.score[c]; });
          }
        });
      });
      return scores;
    }

    function rankedConcerns() {
      var scores = computeScores();
      return Object.keys(scores)
        .filter(function (c) { return scores[c] > 0; })
        .sort(function (a, b) { return scores[b] - scores[a]; });
    }

    function answerLabels(qid) {
      var q = byId(qid);
      var a = state.answers[qid];
      if (!a || !q) return null;
      if (Array.isArray(a)) {
        return a.map(function (v) { var o = findOpt(q, v); return o ? o.label : v; });
      }
      var o = findOpt(q, a);
      return o ? o.label : a;
    }

    function showResults() {
      els.progressBar.style.width = '100%';

      var ranked = rankedConcerns();
      if (!ranked.length) ranked = ['bouffees'];
      var primaryConcern = ranked[0];
      var primary = products[primaryConcern];

      var complements = ranked.slice(1)
        .map(function (c) { return { concern: c, product: products[c] }; })
        .filter(function (x) { return x.product && x.product.handle; })
        .slice(0, 2);

      var html = '<button type="button" class="quiz__results-back" data-quiz-restart>' +
        '<span aria-hidden="true">←</span> Modifier mes réponses</button>' +
        '<div class="quiz__results-head">' +
        '<p class="quiz__results-eyebrow">Ton bilan personnalisé</p>' +
        "<h2 class=\"quiz__results-title\">Voici ce qu'on te recommande</h2>" +
        '</div>';

      html += renderProductCard(primaryConcern, primary, true);

      if (complements.length) {
        html += '<p class="quiz__complements-title">À associer pour un effet complet</p>';
        html += '<div class="quiz__complements">';
        complements.forEach(function (x) { html += renderProductCard(x.concern, x.product, false); });
        html += '</div>';
      }

      html += renderEmail();

      els.steps.hidden = true;
      els.results.hidden = false;
      els.results.innerHTML = html;
      bindResults();
    }

    function renderProductCard(concern, p, isPrimary) {
      if (!p || !p.handle) return '';
      var info = CONCERNS[concern] || {};
      var price = p.compareAt
        ? '<span class="quiz__price"><ins>' + escapeHtml(p.price) + '</ins> <del>' + escapeHtml(p.compareAt) + '</del></span>'
        : '<span class="quiz__price">' + escapeHtml(p.price) + '</span>';
      var cta = p.available && p.variantId
        ? '<button type="button" class="quiz__btn quiz__btn--primary" data-quiz-add="' + p.variantId + '">Ajouter au panier</button>'
        : '<a class="quiz__btn quiz__btn--ghost" href="' + p.url + '">Bientôt de retour</a>';
      var img = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="220" height="220">' : '';

      return '<div class="quiz__product' + (isPrimary ? ' quiz__product--primary' : '') + '">' +
        (isPrimary ? '<span class="quiz__product-badge">Recommandé pour toi</span>' : '') +
        '<div class="quiz__product-media">' + img + '</div>' +
        '<div class="quiz__product-info">' +
          '<h3 class="quiz__product-title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
          (isPrimary && info.why ? '<p class="quiz__product-why">' + escapeHtml(info.why) + '</p>' : '') +
          price + cta +
        '</div>' +
      '</div>';
    }

    function renderEmail() {
      var d = root.dataset;
      var askPhone = d.askPhone === 'true';
      var phonePh = d.phonePlaceholder || 'Ton numéro (optionnel)';
      var phoneHint = d.phoneHint || '';
      var firstNamePh = d.firstNamePlaceholder || 'Ton prénom';
      return '<div class="quiz__email" data-quiz-email>' +
        '<h3 class="quiz__email-title">' + escapeHtml(d.emailHeading || 'Reçois ton bilan par e-mail') + '</h3>' +
        (d.emailSubtext ? '<p class="quiz__email-text">' + escapeHtml(d.emailSubtext) + '</p>' : '') +
        '<form class="quiz__email-form" data-quiz-email-form novalidate>' +
          '<input type="text" name="first_name" required placeholder="' + escapeHtml(firstNamePh) + '" class="quiz__email-input" autocomplete="given-name">' +
          '<input type="email" name="email" required placeholder="Ton adresse e-mail" class="quiz__email-input" autocomplete="email">' +
          (askPhone ? '<input type="tel" name="phone" placeholder="' + escapeHtml(phonePh) + '" class="quiz__email-input quiz__phone-input" autocomplete="tel" inputmode="tel">' : '') +
          (askPhone && phoneHint ? '<p class="quiz__phone-hint">' + escapeHtml(phoneHint) + '</p>' : '') +
          '<button type="submit" class="quiz__btn quiz__btn--primary">' + escapeHtml(d.emailButton || 'Recevoir') + '</button>' +
        '</form>' +
        '<p class="quiz__email-success" data-quiz-email-success hidden></p>' +
      '</div>';
    }

    function bindResults() {
      els.results.querySelectorAll('[data-quiz-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { addToCart(btn.getAttribute('data-quiz-add'), btn); });
      });
      var form = els.results.querySelector('[data-quiz-email-form]');
      if (form) form.addEventListener('submit', onEmailSubmit);

      var restart = els.results.querySelector('[data-quiz-restart]');
      if (restart) restart.addEventListener('click', function () {
        els.results.hidden = true;
        els.steps.hidden = false;
        state.index = QUESTIONS.length - 1;
        renderQuestion();
      });
    }

    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function addToCart(variantId, btn) {
      if (!variantId) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var cartEl = document.querySelector('cart-element[data-cart-drawer]');
          if (cartEl && typeof cartEl.getCart === 'function') { cartEl.getCart(); }
          else { window.location.href = rootUrl() + 'cart'; }
        })
        .catch(function () { window.location.href = rootUrl() + 'cart'; })
        .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    }

    // Regroupe toutes les réponses + dérivés en une seule liste « tags »
    // (segmentable dans Klaviyo via « Quiz - Tags contient … »).
    function buildTags() {
      var tags = [];
      QUESTIONS.forEach(function (q) {
        var a = state.answers[q.id];
        if (!a) return;
        (Array.isArray(a) ? a : [a]).forEach(function (v) {
          var opt = findOpt(q, v);
          if (opt && opt.label) tags.push(opt.label);
        });
      });
      var ranked = rankedConcerns();
      var primaryConcern = ranked[0] || 'bouffees';
      if (CONCERNS[primaryConcern]) tags.push(CONCERNS[primaryConcern].label);
      var p = products[primaryConcern];
      if (p && p.title) tags.push(p.title);
      // dédoublonnage
      return tags.filter(function (t, i) { return tags.indexOf(t) === i; });
    }

    function buildProps() {
      var ranked = rankedConcerns();
      var primaryConcern = ranked[0] || 'bouffees';
      var primaryProduct = products[primaryConcern] || {};
      var secondaryConcern = ranked[1] || null;
      var secondaryProduct = secondaryConcern ? (products[secondaryConcern] || {}) : {};
      return {
        'Quiz - Âge': answerLabels('age'),
        'Quiz - Étape': answerLabels('stage'),
        'Quiz - Symptômes': answerLabels('symptomes'),
        'Quiz - Confort intime': answerLabels('intime'),
        'Quiz - Libido': answerLabels('libido'),
        'Quiz - Priorité': answerLabels('priorite'),
        'Quiz - Préoccupation principale': (CONCERNS[primaryConcern] || {}).label,
        'Quiz - Produit recommandé': primaryProduct.title || null,
        'Quiz - Produit recommandé URL': primaryProduct.url || null,
        'Quiz - Préoccupation complémentaire': secondaryConcern ? (CONCERNS[secondaryConcern] || {}).label : null,
        'Quiz - Produit complémentaire': secondaryProduct.title || null,
        'Quiz - Produit complémentaire URL': secondaryProduct.url || null,
        'Quiz - Tags': buildTags()
      };
    }

    function normalizePhone(raw) {
      if (!raw) return '';
      var s = String(raw).replace(/[\s.\-()]/g, '');
      if (/^\+[1-9]\d{7,14}$/.test(s)) return s;
      if (/^0\d{9}$/.test(s)) return '+33' + s.slice(1);
      if (/^33\d{9}$/.test(s)) return '+' + s;
      return '';
    }

    function subscribeKlaviyo(email, phone, firstName) {
      var key = root.dataset.klaviyoKey;
      var list = root.dataset.klaviyoList;
      var props = buildProps();
      if (phone) props['Quiz - Téléphone'] = phone;
      var phoneE164 = normalizePhone(phone);

      // Renseigne aussi le profil via le JS onsite Klaviyo s'il est présent.
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        try {
          var idData = { email: email };
          if (firstName) idData['$first_name'] = firstName;
          if (phoneE164) idData['$phone_number'] = phoneE164;
          Object.keys(props).forEach(function (k) { idData[k] = props[k]; });
          window.klaviyo.identify(idData);
        } catch (e) {}
      }

      if (!key || !list) {
        console.warn('[Quiz] Klaviyo non configuré (clé publique ou List ID manquant) — abonnement non envoyé pour', email);
        return Promise.resolve();
      }

      var profileAttrs = { email: email, properties: props };
      if (firstName) profileAttrs.first_name = firstName;
      if (phoneE164) profileAttrs.phone_number = phoneE164;

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Quiz Bilan Périménopause',
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (r) {
        if (!r.ok && r.status !== 202) { console.warn('[Quiz] Klaviyo a répondu', r.status); }
        return r;
      });
    }

    function onEmailSubmit(e) {
      e.preventDefault();
      var form = e.currentTarget;
      var firstNameInput = form.querySelector('input[name=first_name]');
      var firstName = firstNameInput ? (firstNameInput.value || '').trim() : '';
      var input = form.querySelector('input[name=email]');
      var email = (input.value || '').trim();
      var phoneInput = form.querySelector('input[name=phone]');
      var phone = phoneInput ? (phoneInput.value || '').trim() : '';
      var successEl = els.results.querySelector('[data-quiz-email-success]');
      if (firstNameInput && !firstName) { firstNameInput.focus(); return; }
      if (!email || email.indexOf('@') < 1) { input.focus(); return; }

      var btn = form.querySelector('button');
      btn.disabled = true;
      btn.classList.add('is-loading');

      function done() {
        var d = root.dataset;
        var msg = d.success || 'Merci ! Ton bilan arrive dans ta boîte mail.';
        if (d.discount) msg += ' Ton code : ' + d.discount;
        form.hidden = true;
        successEl.textContent = msg;
        successEl.hidden = false;
      }
      subscribeKlaviyo(email, phone, firstName).then(done).catch(done);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-quiz]').forEach(init);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
